const DATA = {
  headingBanner: 'The end of context switching',
  headingTitle: 'Never interrupt your workflow again.',
  headingSubtitle: 'No need to switch apps to take notes.',
  video: {
    url: 'https://lazy.b-cdn.net/landing-page/seq-highlights-desktop/Highlights_desktop-00',
    ext: 'png',
    width: 860,
    height: 665,
    frameCount: 191,
  },
  mobileVideo: {
    url: 'https://lazy.b-cdn.net/landing-page/seq-highlights-mobile/Highlights_mobile-00',
    ext: 'png',
    width: 860,
    height: 665,
    frameCount: 191,
  },
}

export default DATA
